import { createElement } from 'react';

import { IconAlertTriangle, IconBell, IconClock, IconMessageStar } from '@tabler/icons-react';

import {
  Account as AccountNotification,
  Feedback,
  IntervalCommentAdded,
  IntervalCompletionStateSubmitted,
  ProjectEndReminder,
  ProjectOverdue,
  ProjectStart,
  Timesheet,
  TimesheetApproval,
  TimesheetRejection,
  task,
} from '@/hooks/useNotifications';

/* ─── Unified notification type ─── */

export type NotificationType =
  | task
  | Timesheet
  | TimesheetApproval
  | TimesheetRejection
  | AccountNotification
  | Feedback
  | ProjectStart
  | ProjectOverdue
  | ProjectEndReminder
  | IntervalCompletionStateSubmitted
  | IntervalCommentAdded;

/* ─── Category system ─── */

export type NotificationCategory = 'action' | 'reminder' | 'alert' | 'feedback';

export interface CategoryConfig {
  color: string;
  icon: React.ReactNode;
}

export function getCategory(n: NotificationType): NotificationCategory {
  switch (n.type) {
    case 'TaskNotifier::Notification':
    case 'TimesheetApprovalNotifier::Notification':
      return 'action';
    case 'TimesheetReminderNotifier::Notification':
    case 'ProjectStartReminderNotifier::Notification':
    case 'ProjectEndReminderNotifier::Notification':
      return 'reminder';
    case 'AccountReminderNotifier::Notification':
    case 'ProjectOverdueNotifier::Notification':
      return 'alert';
    case 'IntervalCompletionStateSubmittedNotifier::Notification':
    case 'IntervalCommentAddedNotifier::Notification':
      return 'action';
    case 'FeedbackNotifier::Notification':
      return 'feedback';
    default:
      return 'alert';
  }
}

export const categoryConfig: Record<NotificationCategory, CategoryConfig> = {
  action: {
    color: 'blue',
    icon: createElement(IconBell, { size: 16 }),
  },
  reminder: {
    color: 'orange',
    icon: createElement(IconClock, { size: 16 }),
  },
  alert: {
    color: 'red',
    icon: createElement(IconAlertTriangle, { size: 16 }),
  },
  feedback: {
    color: 'violet',
    icon: createElement(IconMessageStar, { size: 16 }),
  },
};
